import { morphoPools, morphoTypeMarkets } from '@1delta/data-sdk'
import { AdditionalYields } from '../../../types'
import { MORPHO_LENS } from '../../user-data/morpho/userCallBuild'
import { convertMarketsToMorphoResponse } from './convertPublic'
import { fetchMorphoMarkets } from './fetchPublic'
import { buildListaCall } from '../lista/publicCallBuild'
import lodash from 'lodash'

const { chunk } = lodash

export const MARKET_CHUNK_SIZE = 50

export async function fetchMorphoPublicData(
  chainId: string,
  yields: AdditionalYields = {
    intrinsicYields: {},
    lenderRewards: {},
    loaded: true,
  },
) {
  const mbData = await fetchMorphoMarkets(chainId)
  return convertMarketsToMorphoResponse(mbData, chainId, yields)
}

export function buildMorphoCall(chainId: string, marketsOverride?: string[]) {
  const markets =
    marketsOverride ?? morphoTypeMarkets()?.MORPHO_BLUE?.[chainId] ?? []
  const mb = morphoPools()?.MORPHO_BLUE?.[chainId]
  if (!mb || markets.length === 0) return []

  const marketChunks = chunk(markets, MARKET_CHUNK_SIZE)

  return marketChunks.map((marketGroup) => ({
    address: MORPHO_LENS[chainId],
    name: 'getMarketDataCompact',
    params: [mb, marketGroup],
  }))
}

export function buildMorphoTypeCall(
  chainId: string,
  lender: string,
  marketsOVerride?: string[],
) {
  if (lender.startsWith('LISTA_DAO'))
    return buildListaCall(chainId, marketsOVerride)
  return buildMorphoCall(chainId, marketsOVerride)
}
